export const VOTING_CRITERIA = {
  squareMeter: { label: "square meter", value: "area" },
  resident: { label: "resident", value: "apartment" },
};

export const MEETING_STATUS = {
  draft: "created",
  discussion_period: "discussion_period",
  discussion_ended: "discussion_ended",
  voting_period: "voting_period",
  voting_ended: "voting_ended",
  report_done: "report_done",
  canceled: "canceled",
};

export const VOTING_OPTIONS = {
  yes: "in_favor",
  no: "against",
  neutral: "abstained",
};

/* use as mixin to add const into component scope */
export default {
  created() {
    this.VOTING_CRITERIA = VOTING_CRITERIA;
    this.MEETING_STATUS = MEETING_STATUS;
  },
};
